module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa bảng giá",
      "breadcrumbs": [{
        title: 'Quản lý bảng giá',
        route: {
          name: 'price-table'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('el-form', {
    ref: "create-price-table-form",
    staticClass: "margin-top",
    attrs: {
      "label-position": "top",
      "rules": _vm.rules,
      "model": _vm.localPriceTable,
      "label-width": "150px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validatorBeforeSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localPriceTable.name),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "name", $$v)
      },
      expression: "localPriceTable.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Hãng vận chuyển",
      "prop": "carrier_id"
    }
  }, [_c('el-select', {
    staticClass: "display-block",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn hãng vận chuyển"
    },
    model: {
      value: (_vm.localPriceTable.carrier_id),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "carrier_id", $$v)
      },
      expression: "localPriceTable.carrier_id"
    }
  }, _vm._l((_vm.carriers), function(carrier) {
    return _c('el-option', {
      key: carrier.id,
      attrs: {
        "label": carrier.name,
        "value": carrier.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Dịch vụ",
      "prop": "service_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn dịch vụ"
    },
    model: {
      value: (_vm.localPriceTable.service_id),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "service_id", $$v)
      },
      expression: "localPriceTable.service_id"
    }
  }, _vm._l((_vm.services), function(service) {
    return _c('el-option', {
      key: service.id,
      attrs: {
        "label": service.name,
        "value": service.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mapping id",
      "prop": "service_mapping_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Mapping id"
    },
    model: {
      value: (_vm.localPriceTable.service_mapping_id),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "service_mapping_id", $$v)
      },
      expression: "localPriceTable.service_mapping_id"
    }
  }, _vm._l((_vm.priceTableHelpers.services), function(sGroup, key, index) {
    return _c('el-option-group', {
      key: key,
      attrs: {
        "label": key
      }
    }, _vm._l((sGroup), function(service, key, index) {
      return _c('el-option', {
        key: key,
        attrs: {
          "label": service,
          "value": key
        }
      })
    }), 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Giờ áp dụng",
      "prop": "hour_apply"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Giờ áp dụng"
    },
    model: {
      value: (_vm.localPriceTable.hour_apply),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "hour_apply", $$v)
      },
      expression: "localPriceTable.hour_apply"
    }
  }, [_c('div', {
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v("Giờ")])])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "adddon-3",
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Thời gian dự kiến giao hàng",
      "prop": "expected_delivery"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "Thời gian dự kiến giao hàng"
    },
    model: {
      value: (_vm.localPriceTable.expected_delivery),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "expected_delivery", $$v)
      },
      expression: "localPriceTable.expected_delivery"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "append",
      "placeholder": "Select"
    },
    slot: "append",
    model: {
      value: (_vm.localPriceTable.expected_unit),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "expected_unit", $$v)
      },
      expression: "localPriceTable.expected_unit"
    }
  }, _vm._l((_vm.priceTableHelpers.units), function(unit, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": unit,
        "value": index
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả dịch vụ",
      "prop": "service_description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mô tả dịch vụ"
    },
    model: {
      value: (_vm.localPriceTable.service_description),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "service_description", $$v)
      },
      expression: "localPriceTable.service_description"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "TP đi",
      "prop": "city_from_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn TP đi"
    },
    model: {
      value: (_vm.localPriceTable.city_from_id),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "city_from_id", $$v)
      },
      expression: "localPriceTable.city_from_id"
    }
  }, _vm._l((_vm.cities), function(city) {
    return _c('el-option', {
      key: city.id,
      attrs: {
        "label": city.name,
        "value": city.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Vùng miền đến",
      "prop": "region_to_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn vùng miền đến"
    },
    model: {
      value: (_vm.localPriceTable.region_to_id),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "region_to_id", $$v)
      },
      expression: "localPriceTable.region_to_id"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.id,
      attrs: {
        "label": region.name,
        "value": region.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Giá",
      "prop": "amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Giá"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('amount')
      },
      "blur": function($event) {
        return _vm.addZero('amount')
      }
    },
    model: {
      value: (_vm.localPriceTable.amount),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "amount", $$v)
      },
      expression: "localPriceTable.amount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPriceTable.amount)))])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí thu hộ tối thiểu",
      "prop": "cod_min_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí thu hộ tối thiểu"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('cod_min_fee')
      },
      "blur": function($event) {
        return _vm.addZero('cod_min_fee')
      }
    },
    model: {
      value: (_vm.localPriceTable.cod_min_fee),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "cod_min_fee", $$v)
      },
      expression: "localPriceTable.cod_min_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPriceTable.cod_min_fee)))])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí thu hộ (COD)",
      "prop": "cod_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phí thu hộ (COD)"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('cod_fee')
      },
      "blur": function($event) {
        return _vm.addZero('cod_fee')
      }
    },
    model: {
      value: (_vm.localPriceTable.cod_fee),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "cod_fee", $$v)
      },
      expression: "localPriceTable.cod_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localPriceTable.cod_fee, 3)) + " %")])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Giá trị đơn hàng áp dụng",
      "prop": "cod_apply"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Giá trị đơn hàng áp dụng"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('cod_apply')
      },
      "blur": function($event) {
        return _vm.addZero('cod_apply')
      }
    },
    model: {
      value: (_vm.localPriceTable.cod_apply),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "cod_apply", $$v)
      },
      expression: "localPriceTable.cod_apply"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPriceTable.cod_apply)))])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cân nặng khởi điểm",
      "prop": "weight_first"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cân nặng khởi điểm"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('weight_first')
      },
      "blur": function($event) {
        return _vm.addZero('weight_first')
      }
    },
    model: {
      value: (_vm.localPriceTable.weight_first),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "weight_first", $$v)
      },
      expression: "localPriceTable.weight_first"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("gam")(_vm.localPriceTable.weight_first)))])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cân nặng tối đa",
      "prop": "maximum_weight"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Cân nặng tối đa"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('maximum_weight')
      },
      "blur": function($event) {
        return _vm.addZero('maximum_weight')
      }
    },
    model: {
      value: (_vm.localPriceTable.maximum_weight),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "maximum_weight", $$v)
      },
      expression: "localPriceTable.maximum_weight"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("gam")(_vm.localPriceTable.maximum_weight)))])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Bước nhảy",
      "prop": "weight_step"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Bước nhảy"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('weight_step')
      },
      "blur": function($event) {
        return _vm.addZero('weight_step')
      }
    },
    model: {
      value: (_vm.localPriceTable.weight_step),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "weight_step", $$v)
      },
      expression: "localPriceTable.weight_step"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-orange"
  }, [_vm._v(_vm._s(_vm._f("gam")(_vm.localPriceTable.weight_step)))])])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Giá bước nhảy",
      "prop": "weight_step_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Giá bước nhảy"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('weight_step_fee')
      },
      "blur": function($event) {
        return _vm.addZero('weight_step_fee')
      }
    },
    model: {
      value: (_vm.localPriceTable.weight_step_fee),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "weight_step_fee", $$v)
      },
      expression: "localPriceTable.weight_step_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPriceTable.weight_step_fee)))])])], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "adddon-2",
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phụ phí ngoại thành",
      "prop": "location_step_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phụ phí ngoại thành"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('location_step_fee')
      },
      "blur": function($event) {
        return _vm.addZero('location_step_fee')
      }
    },
    model: {
      value: (_vm.localPriceTable.location_step_fee),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "location_step_fee", $$v)
      },
      expression: "localPriceTable.location_step_fee"
    }
  }, [_c('span', {
    staticClass: "text-red",
    attrs: {
      "slot": "append"
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm._f("vnd")(_vm.localPriceTable.location_step_fee)))]), _vm._v(" "), _c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "Select"
    },
    slot: "prepend",
    model: {
      value: (_vm.localPriceTable.lsf_type),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "lsf_type", $$v)
      },
      expression: "localPriceTable.lsf_type"
    }
  }, _vm._l((_vm.priceTableHelpers.lsf_types), function(lsf_type, key, index) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": lsf_type,
        "value": parseInt(key)
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "adddon-1",
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phí chuyển hoàn",
      "prop": "return_fee"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": "Phí chuyển hoàn"
    },
    on: {
      "focus": function($event) {
        return _vm.removeZero('return_fee')
      },
      "blur": function($event) {
        return _vm.addZero('return_fee')
      }
    },
    model: {
      value: (_vm.localPriceTable.return_fee),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "return_fee", $$v)
      },
      expression: "localPriceTable.return_fee"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.localPriceTable.return_fee, 3)) + " " + _vm._s(_vm.priceTableHelpers.currencies[_vm.localPriceTable.return_unit]))])]), _vm._v(" "), _c('el-select', {
    attrs: {
      "slot": "prepend",
      "placeholder": "Select"
    },
    slot: "prepend",
    model: {
      value: (_vm.localPriceTable.return_unit),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "return_unit", $$v)
      },
      expression: "localPriceTable.return_unit"
    }
  }, _vm._l((_vm.priceTableHelpers.currencies), function(currency, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": currency,
        "value": parseInt(index)
      }
    })
  }), 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Áp dụng riêng cho khách hàng",
      "prop": "apply_only_customer"
    }
  }, [_c('select-client', {
    model: {
      value: (_vm.localPriceTable.apply_only_customer),
      callback: function($$v) {
        _vm.$set(_vm.localPriceTable, "apply_only_customer", $$v)
      },
      expression: "localPriceTable.apply_only_customer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "adddon-1",
    attrs: {
      "span": 12
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7f601ac7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pricetable/EditPriceTable.vue
// module id = 724
// module chunks = 1